import { render, staticRenderFns } from "./SponsoredCarousel.vue?vue&type=template&id=39a27f42&scoped=true"
import script from "./SponsoredCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredCarousel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredCarousel.vue?vue&type=style&index=0&id=39a27f42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a27f42",
  null
  
)

export default component.exports